import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface DemoModeIndicatorProps {
  message?: string;
  showIcon?: boolean;
  position?: 'top' | 'bottom' | 'inline';
}

export const DemoModeIndicator: React.FC<DemoModeIndicatorProps> = ({
  message = 'Demo Mode - Using Sample Data',
  showIcon = true,
  position = 'top'
}) => {
  const isStaticDeployment = () => {
    return window.location.hostname.includes('netlify.app') ||
           window.location.hostname.includes('github.io') ||
           process.env.REACT_APP_USE_MOCK_DATA === 'true';
  };

  // Only show in demo mode
  if (!isStaticDeployment()) {
    return null;
  }

  const baseClasses = 'bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-2 rounded-lg flex items-center gap-2';
  
  const positionClasses = {
    top: 'fixed top-4 left-1/2 transform -translate-x-1/2 z-50 shadow-lg',
    bottom: 'fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 shadow-lg',
    inline: 'my-4'
  };

  return (
    <div className={`${baseClasses} ${positionClasses[position]}`}>
      {showIcon && <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0" />}
      <span className="text-sm font-medium">{message}</span>
    </div>
  );
};

export const InlineDemoNotice: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const isStaticDeployment = () => {
    return window.location.hostname.includes('netlify.app') ||
           window.location.hostname.includes('github.io') ||
           process.env.REACT_APP_USE_MOCK_DATA === 'true';
  };

  if (!isStaticDeployment()) {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon className="h-5 w-5 text-blue-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-blue-800">Demo Mode Active</h3>
          <div className="mt-2 text-sm text-blue-700">
            {children || (
              <p>
                You are viewing sample data. To work with real data, please run the application 
                locally with the Laravel backend.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};